import dayjs from 'dayjs';
export { Dayjs } from 'dayjs';
import 'dayjs/locale/zh-cn';
import 'dayjs/plugin/advancedFormat';
import 'dayjs/plugin/arraySupport';
import 'dayjs/plugin/badMutable';
import 'dayjs/plugin/buddhistEra';
import 'dayjs/plugin/calendar';
import 'dayjs/plugin/customParseFormat';
import 'dayjs/plugin/dayOfYear';
import 'dayjs/plugin/devHelper';
import 'dayjs/plugin/duration';
import 'dayjs/plugin/isBetween';
import 'dayjs/plugin/isLeapYear';
import 'dayjs/plugin/isMoment';
import 'dayjs/plugin/isSameOrAfter';
import 'dayjs/plugin/isSameOrBefore';
import isToday from 'dayjs/plugin/isToday';
import 'dayjs/plugin/isTomorrow';
import isYesterday from 'dayjs/plugin/isYesterday';
import 'dayjs/plugin/isoWeek';
import 'dayjs/plugin/isoWeeksInYear';
import 'dayjs/plugin/localeData';
import 'dayjs/plugin/localizedFormat';
import 'dayjs/plugin/minMax';
import 'dayjs/plugin/objectSupport';
import 'dayjs/plugin/pluralGetSet';
import 'dayjs/plugin/preParsePostFormat';
import 'dayjs/plugin/quarterOfYear';
import 'dayjs/plugin/relativeTime';
import 'dayjs/plugin/timezone';
import 'dayjs/plugin/toArray';
import 'dayjs/plugin/toObject';
import 'dayjs/plugin/updateLocale';
import 'dayjs/plugin/utc';
import 'dayjs/plugin/weekOfYear';
import 'dayjs/plugin/weekYear';
import 'dayjs/plugin/weekday';
import { parse } from 'qs';
import Decimal from 'decimal.js';
import cryptoJs from 'crypto-js';
import Cookies from 'js-cookie';

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/**
 * @description: 格式化时长，传入时长(秒)，格式化为x天x小时x分钟x秒
 * @param { number } duration 时长（秒）
 * @param { boolean } needSeconds 是否展示处理后的秒数，默认展示，时长小于60秒时无法隐藏，false 不生效
 * @param { boolean } hideZero 是否隐藏末位0 ，如 1天0小时0分钟0秒 时展示为 1天，默认不隐藏
 * @return { string } x天x小时x分钟x秒
 */
var formatSeconds = function formatSeconds(duration, needSeconds, hideZero) {
  if (needSeconds === void 0) {
    needSeconds = true;
  }
  if (hideZero === void 0) {
    hideZero = false;
  }
  var days = Math.floor(duration / (3600 * 24));
  var hours = Math.floor((duration - days * 3600 * 24) / 3600);
  var minutes = Math.floor(duration % 3600 / 60);
  var seconds = duration % 60;
  var showSeconds = "" + (needSeconds || !(days || hours || minutes) ? seconds + "\u79D2" : '');
  if (days) {
    showSeconds = days + "\u5929" + hours + "\u5C0F\u65F6" + minutes + "\u5206\u949F" + showSeconds;
  } else if (hours) {
    showSeconds = hours + "\u5C0F\u65F6" + minutes + "\u5206\u949F" + showSeconds;
  } else if (minutes) {
    showSeconds = minutes + "\u5206\u949F" + showSeconds;
  }
  if (hideZero) {
    var replaceList = needSeconds ? ['天0小时0分钟0秒', '时0分钟0秒', '钟0秒'] : ['天0小时0分钟', '时0分钟'];
    replaceList.forEach(function (i) {
      if (showSeconds.endsWith(i)) {
        showSeconds = showSeconds.replace(i, i[0]);
      }
    });
  }
  return showSeconds;
};
/**
 * @description: 最近日期（天）格式化，具体格式化规则如下：
 * 1. 一分钟内：刚刚
 * 2. 一小时内：几分钟前
 * 3. 一天内：今天/上午/下午/凌晨... 时:分
 * 4. 自然天第二天：昨天 时:分
 * 5. 未跨年时：月-日 时:分
 * 6. 跨年：年-月-日 时:分
 * @param {number | string} dateTime 只允许传入时间戳或 YYYY-MM-DD HH:mm:ss 格式
 * @param {FormatDateTimeConfig} config 格式化配置项
 * @param {boolean} [config.needTodayText=false] 当为今日时，是否需要时间段文案，默认展示为【今日 12:30】，需要时展示为【中午 12:30】，时间段规则如下：
 * 凌晨 00:00-06:00 早上 06:00—09:00 上午 09:00-11:00 中午 11:00-13:00 下午 13:00-18:00 晚上 18:00-00:00
 * @param {string} [config.timeFormat='HH:mm'] 时分秒展示格式，默认为 'HH:mm' ,可传入 'HH:mm:ss'、'HH' 等通用时分秒格式规则进行修改
 * @return {string}
 */
var formatDateTime = function formatDateTime(dateTime, config) {
  dayjs.extend(isToday);
  dayjs.extend(isYesterday);
  // 默认配置
  var defaultConfig = {
    timeFormat: 'HH:mm',
    needTodayText: false
  };
  var _defaultConfig$config = _extends({}, defaultConfig, config),
    timeFormat = _defaultConfig$config.timeFormat,
    needTodayText = _defaultConfig$config.needTodayText;
  if (!dateTime) return '';
  // 时间戳换算为毫秒
  if (typeof dateTime === 'number') {
    dateTime = dateTime.toString().length === 10 ? dateTime * 1000 : dateTime;
  }
  var dateFormatText = 'YYYY-MM-DD';
  // 今天
  if (dayjs(dateTime).isToday()) {
    var diffValueMinute = dayjs(dateTime).diff(dayjs(), 'm');
    if (diffValueMinute === 0) return '刚刚';
    if (diffValueMinute < 0 && diffValueMinute > -60) return Math.abs(diffValueMinute) + "\u5206\u949F\u524D";
    // 处理上下午
    dateFormatText = needTodayText ? dayjs(dateTime).format('a') : '今天';
  } else if (dayjs(dateTime).isYesterday()) {
    // 昨天
    dateFormatText = '昨天';
  } else if (dayjs(dateTime).format('YYYY') === dayjs().format('YYYY')) {
    // 未跨年
    dateFormatText = 'MM-DD';
  }
  return dayjs(dateTime).format(dateFormatText + " " + timeFormat);
};

dayjs.locale('zh-cn');

/**
 * @func
 * @version 0.0.1
 * @param {string} url = location.href
 * @param [options] qs.parse配置项
 * @return {GetUrlQueryType}
 * @desc: 以key:value形式返回url上所有参数，重复参数合并为数组，字符串对象转为对象，数组参数合并为一个数组
 * @example 获取所有参数：getUrlQuery('http://666.com/v1?name=中文&sort=1&arr=0&arr=aaa&list[]=1&list[]=2&obj=%7B%22a%22:4,%22b%22:[1,2],%22c%22:%7B%22f%22:4%7D%7D#锚点');
 * @example 获取指定参数：getUrlQuery(http://666.com/v1?name=土豆').name;
 */
// 判断是否为对象字符串
var isJson = function isJson(str) {
  try {
    var obj = JSON.parse(str);
    // 剔除数字
    if (typeof obj === 'number') {
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
};
var getUrlQuery = function getUrlQuery(url, option) {
  if (url === void 0) {
    url = window.location.href;
  }
  var result = {};
  var queryStr = url.split('?')[1];
  if (!queryStr) return result;
  queryStr = queryStr.split('#')[0];
  result = parse(queryStr, option);
  // 处理对象
  Object.keys(result).forEach(function (key) {
    if (isJson(result[key])) {
      result[key] = JSON.parse(result[key]);
    }
  });
  return result;
};

var MoneyUnit;
(function (MoneyUnit) {
  MoneyUnit["YUAN"] = "YUAN";
  MoneyUnit["JIAO"] = "JIAO";
  MoneyUnit["FEN"] = "FEN";
})(MoneyUnit || (MoneyUnit = {}));
/**
 * @description: 千分隔
 * @param {number} val
 * @return {*}
 */
var handleOnDivide = function handleOnDivide(val) {
  var target = Number(val);
  return target.toLocaleString();
};
var divValue = function divValue(unit) {
  var _MoneyUnit$FEN$MoneyU;
  return (_MoneyUnit$FEN$MoneyU = {}, _MoneyUnit$FEN$MoneyU[MoneyUnit.FEN] = 100, _MoneyUnit$FEN$MoneyU[MoneyUnit.JIAO] = 10, _MoneyUnit$FEN$MoneyU[MoneyUnit.YUAN] = 1, _MoneyUnit$FEN$MoneyU)[unit] || 100;
};
/**
 * @description: 数字转金额
 * @param {number | string} value - 所需要处理的数据，传入单位为 分
 * @param {object} options - 配置项
 * @param {number} [options.precision=2] - 小数位数
 * @param {boolean} [options.sign=false] - 是否展示单位 ¥
 * @param {MoneyUnit} [options.unit=MoneyUnit.FEN] - 除数 默认除 100，即传入分 返回 元
 * @param {Decimal.Rounding} [options.rounding=4] - 取整模式，默认四舍五入
 * @see {@link https://lixingwu.gitee.io/decimal.js_cn/cn/index.html#modes | Decimal.Rounding}
 * @return {string}
 */
var formatMoney = function formatMoney(value, options) {
  var defaultConfig = {
    precision: 2,
    sign: false,
    rounding: 4,
    unit: MoneyUnit.FEN
  };
  var _defaultConfig$option = _extends({}, defaultConfig, options),
    precision = _defaultConfig$option.precision,
    sign = _defaultConfig$option.sign,
    rounding = _defaultConfig$option.rounding,
    unit = _defaultConfig$option.unit;
  var target = Decimal.set({
    rounding: rounding
  }).div(new Decimal(value), divValue(unit)).toFixed(precision);
  // 千分隔处理
  var temp = target.split('.');
  var result = handleOnDivide(temp[0]);
  var symbol = sign ? '¥' : '';
  var suffix = temp[1] ? "." + temp[1] : '';
  /**
   * 还原 Decimal 全局设置
   * https://mikemcl.github.io/decimal.js/#Dset
   */
  Decimal.set({
    defaults: true
  });
  return "" + symbol + result + suffix;
};

/*
 * @Date: 2022-03-07 15:55:24
 * @LastEditors: xiaokun
 * @Description: 数据精度处理
 */

/**
 * @Author: lidan
 * @Date: 2022-03-10 14:10:05
 * @LastEditors: lidan
 * @Description:
 *  可使用formatFileSize方法获取合适单位的文件大小格式
 *  可使用formatFileSizeByUnit方法获取指定单位的文件大小格式
 */
/**
 * 保留小数点固定位数
 * @param value 原数据
 * @param point 小数点位数
 * @returns 保留固定的小数点位数之后的新数据
 */
function decimalToFixed(value, point) {
  var decimalNumber = new Decimal(value);
  return decimalNumber.toFixed(point);
}
/**
 * 获取指定单位的文件大小格式
 * @param fileSize 文件大小
 * @param unit 指定单位
 * @param point 小数点位数
 * @param mode
 *    可选值 SYSTEM NORMAL
 *    SYSTEM 按系统模式换算（1000） 某些电脑系统磁盘文件大小换算模式为1000
 *    NORMAL 按普通模式换算 （1024）
 * @returns 指定文件单位的文件大小格式数据
 */
function formatFileSizeByUnit(fileSize, unit, point, mode) {
  if (unit === void 0) {
    unit = 'KB';
  }
  if (point === void 0) {
    point = 2;
  }
  if (mode === void 0) {
    mode = 'SYSTEM';
  }
  var upperUnit = unit.toUpperCase();
  var divide = mode === 'SYSTEM' ? 1000 : 1024;
  var units = ['B', 'KB', 'MB', 'GB'];
  var index = units.indexOf(upperUnit);
  return decimalToFixed(fileSize / Math.pow(divide, index), point) + upperUnit;
}
/**
 * 根据文件大小数值自动换算文件大小单位
 * @param fileSize 文件大小
 * @param point 小数点位数
 * @param mode
 *    可选值 SYSTEM NORMAL
 *    SYSTEM 按系统模式换算（1000） 某些电脑系统磁盘文件大小换算模式为1000
 *    NORMAL 按普通模式换算 （1024）
 * @returns 自适应的文件大小单位格式数据
 */
function formatFileSize(fileSize, point, mode) {
  if (point === void 0) {
    point = 2;
  }
  if (mode === void 0) {
    mode = 'SYSTEM';
  }
  var divide = mode === 'SYSTEM' ? 1000 : 1024;
  if (fileSize < divide) {
    return decimalToFixed(fileSize, point) + 'B';
  } else if (fileSize < Math.pow(divide, 2)) {
    var temp = fileSize / divide;
    return decimalToFixed(temp, point) + 'KB';
  } else if (fileSize < Math.pow(divide, 3)) {
    var _temp = fileSize / Math.pow(divide, 2);
    return decimalToFixed(_temp, point) + 'MB';
  } else {
    var _temp2 = fileSize / Math.pow(divide, 3);
    return decimalToFixed(_temp2, point) + 'GB';
  }
}

/*
 * @Date: 2022-03-14 14:12:00
 * @LastEditors: xiaokun
 * @Description: storage 操作方法
 */
/** storage 通用部分 --- strat */
var setItem = function setItem(key, value, storage) {
  if (storage === void 0) {
    storage = window.sessionStorage;
  }
  var setValue = '';
  try {
    setValue = JSON.stringify(value);
  } catch (_unused) {}
  storage.setItem(key, setValue);
};
var getItem = function getItem(key, storage) {
  if (storage === void 0) {
    storage = window.sessionStorage;
  }
  var value = storage.getItem(key);
  if (!value) return undefined;
  try {
    return JSON.parse(value);
  } catch (_unused2) {}
  return undefined;
};
var removeItem = function removeItem(key, storage) {
  if (storage === void 0) {
    storage = window.sessionStorage;
  }
  storage.removeItem(key);
};
/** storage 通用部分 --- end */
/** sessionStorage */
var setSessionItem = function setSessionItem(key, value) {
  setItem(key, value);
};
var getSessionItem = function getSessionItem(key) {
  return getItem(key);
};
var removeSessionItem = function removeSessionItem(key) {
  removeItem(key);
};
/** localStorage */
var setLocalItem = function setLocalItem(key, value) {
  setItem(key, value, window.localStorage);
};
var getLocalItem = function getLocalItem(key) {
  return getItem(key, window.localStorage);
};
var removeLoaclItem = function removeLoaclItem(key) {
  removeItem(key, window.localStorage);
};
/** cookie */
var setCookieItem = function setCookieItem() {
  var setValue = '';
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }
  try {
    setValue = typeof params[1] === 'object' ? JSON.stringify(params[1]) : params[1];
  } catch (_unused3) {}
  params[1] = setValue;
  return Cookies.set.apply(Cookies, params);
};
var getCookieItem = function getCookieItem(key) {
  var value = Cookies.get(key);
  if (!value) return undefined;
  try {
    return JSON.parse(value);
  } catch (_unused4) {}
  return undefined;
};
var removeCookieItem = function removeCookieItem() {
  return Cookies.remove.apply(Cookies, arguments);
};
var storage = {
  setSessionItem: setSessionItem,
  getSessionItem: getSessionItem,
  removeSessionItem: removeSessionItem,
  setLocalItem: setLocalItem,
  getLocalItem: getLocalItem,
  removeLoaclItem: removeLoaclItem,
  setCookieItem: setCookieItem,
  getCookieItem: getCookieItem,
  removeCookieItem: removeCookieItem
};

/*
 * @Author: xiaokun
 * @Date: 2022-02-17 11:18:03
 * @LastEditors: xiaokun
 * @Description: 用户数据读写函数
 */
var removeUser = function removeUser(key) {
  if (key === void 0) {
    key = 'user';
  }
  storage.removeLoaclItem(key);
};
/**
 * @description: 存入用户信息
 * @param {object} value
 * @param {string} key - 默认 key 为 user, 可传入修改
 */
var setUser = function setUser(value, key) {
  if (key === void 0) {
    key = 'user';
  }
  storage.setLocalItem(key, value);
};
/**
 * @description: 获取用户信息
 * @param {string} key - 默认 key 为 user, 可传入修改为 qw-user
 */
var getUser = function getUser(key) {
  if (key === void 0) {
    key = 'user';
  }
  var user = storage.getLocalItem(key);
  if (!user) return undefined;
  try {
    return user;
  } catch (_unused) {}
  return undefined;
};
/**
 * @description: 获取用户 sid
 * @param {string} key - 默认 key 为 user, 可传入修改为 qw-user
 */
var getSessionId = function getSessionId(key) {
  if (key === void 0) {
    key = 'user';
  }
  var user = getUser(key);
  if (!user || !user.sid) return undefined;
  try {
    return user.sid;
  } catch (_unused2) {}
  return undefined;
};
var userStorage = {
  setUser: setUser,
  getUser: getUser,
  removeUser: removeUser,
  getSessionId: getSessionId
};

/*
 * @Author: zhaoyj
 * @Date: 2022-03-22 16:29:53
 * @LastEditTime: 2022-03-22 18:53:01
 * @LastEditors: zhaoyj
 * @Description:
 */
/**
 *
 * @param {number} duration 秒
 * @param {string} format
 * d/dd 天
 * h/hh 小时
 * m/mm 分钟
 * s/ss 秒
 * @returns {string}
 */
var durationFormat = function durationFormat(duration, format) {
  if (format === void 0) {
    format = 'hh:mm:ss';
  }
  if (!duration || typeof duration !== 'number') return '';
  var dayReg = /([Dd])\1?/g;
  var hourReg = /([Hh])\1?/g;
  var minuteReg = /([Mm])\1?/g;
  var secondReg = /([Ss])\1?/g;
  var days = '';
  var hours = '';
  var minutes = '';
  var seconds = '';
  var ONE_MINUTE = 60;
  var ONE_HOUR = ONE_MINUTE * 60;
  var ONE_DAY = ONE_HOUR * 24;
  return format.replace(dayReg, function ($0) {
    days = "" + ~~(duration / ONE_DAY);
    return days.padStart($0.length, '0');
  }).replace(hourReg, function ($0) {
    var filterDays = days ? duration % ONE_DAY : duration;
    hours = "" + ~~(filterDays / ONE_HOUR);
    return hours.padStart($0.length, '0');
  }).replace(minuteReg, function ($0) {
    var filterDays = days ? duration % ONE_DAY : duration;
    var filterHours = hours ? filterDays % ONE_HOUR : filterDays;
    minutes = "" + ~~(filterHours / ONE_MINUTE);
    return minutes.padStart($0.length, '0');
  }).replace(secondReg, function ($0) {
    var filterDays = days ? duration % ONE_DAY : duration;
    var filterHours = hours ? filterDays % ONE_HOUR : filterDays;
    seconds = minutes ? "" + filterHours % ONE_MINUTE : "" + filterHours;
    return seconds.padStart($0.length, '0');
  });
};

/*
 * @Date: 2022-03-29 16:21:49
 * @LastEditors: xiaokun
 * @Description: 文件下载
 */
/**
 * @description: 文件下载，目前不支持跨域文件重命名
 * @param {string} url 文件地址
 * @param {string} title 需重命名的名称
 * @return {*}
 */
var download = function download(url, title) {
  var a = document.createElement('a');
  var event = new MouseEvent('click');
  // 下载图名字
  a.download = title || '';
  // url
  a.href = url;
  // 合成函数，执行下载
  a.dispatchEvent(event);
  a = null;
};

function getUser$1(userKey) {
  if (userKey) {
    return userStorage.getUser(userKey);
  }
  return userStorage.getUser('user') || userStorage.getUser('qw-user');
}
function matchCorpId(domain) {
  var matchGroup = domain.match(/([A-Za-z0-9-]+)-qw-scrm/);
  if (!matchGroup) {
    return undefined;
  }
  var corpId = matchGroup[1];
  var index = matchGroup['index'];
  return {
    corpId: corpId,
    index: index,
    domain: domain
  };
}
/**判断是否是私有云 */
function isPrivate() {
  var _window$envConfig;
  return ((_window$envConfig = window.envConfig) == null ? void 0 : _window$envConfig.VUE_APP_CONFIG_CORPID) !== '0';
}
function getDomainUrl(userKey) {
  var user = getUser$1(userKey);
  if (user != null && user.domain) {
    return user.domain;
  }
  return location.origin;
}
function makeFullUrl(url) {
  if (url.includes('//')) {
    return url;
  }
  return "https://" + url;
}
function removeCorpId(url) {
  var newUrl = makeFullUrl(url);
  var match = matchCorpId(newUrl);
  if (!match) return newUrl;
  return newUrl.replace(match.corpId + '-', '');
}
function getPrivateCloudDomain(domainUrl, userOrigin) {
  return removeCorpId(userOrigin || domainUrl);
}
function appendCorpId(url, corpId) {
  if (url.includes('//')) {
    var _url$split = url.split('//'),
      prefix = _url$split[0],
      origin = _url$split[1];
    return prefix + "//" + corpId + "-" + origin;
  }
  return "https://" + corpId + "-" + url;
}
function getDomain(domainUrl, userOrigin) {
  var match = matchCorpId(domainUrl);
  if (!match) {
    console.error('未获取到domain前缀，组装url失败');
    return userOrigin || domainUrl;
  }
  var corpId = match.corpId;
  if (userOrigin) {
    return appendCorpId(userOrigin, corpId);
  }
  return makeFullUrl(domainUrl);
}
/**
 * 获取domain路由前缀
 * - 私有云环境下，调用该函数返回的接口始终为空
 */
function getDomainAffix(userStorageKey) {
  if (isPrivate()) {
    return '';
  }
  var domainUrl = getDomainUrl(userStorageKey);
  var match = matchCorpId(domainUrl);
  if (!match) {
    console.error('获取domain前缀失败');
    return '';
  }
  return match.corpId;
}
/**
 * 获取当前环境的完整路由，支持外部传入自定义的url
 * @param option 选项
 * @returns 最终的url
 */
function getDecorateOrigin(option) {
  if (option === void 0) {
    option = {};
  }
  var _option = option,
    origin = _option.origin,
    userKey = _option.userKey;
  var domainUrl = getDomainUrl(userKey);
  if (isPrivate()) {
    return getPrivateCloudDomain(domainUrl, origin);
  }
  return getDomain(domainUrl, origin);
}

function isEllipsis(el) {
  if (!el) {
    return false;
  }
  var _el$clientWidth = el.clientWidth,
    clientWidth = _el$clientWidth === void 0 ? 0 : _el$clientWidth,
    _el$clientHeight = el.clientHeight,
    clientHeight = _el$clientHeight === void 0 ? 0 : _el$clientHeight,
    _el$scrollWidth = el.scrollWidth,
    scrollWidth = _el$scrollWidth === void 0 ? 0 : _el$scrollWidth,
    _el$scrollHeight = el.scrollHeight,
    scrollHeight = _el$scrollHeight === void 0 ? 0 : _el$scrollHeight;
  if (scrollWidth > clientWidth || scrollHeight > clientHeight) {
    return true;
  }
  return false;
}

function isLoadScript(url) {
  var scripts = document.scripts;
  for (var i = 0; i < scripts.length; i++) {
    var _scripts$i;
    if ((_scripts$i = scripts[i]) != null && _scripts$i.src.includes(url)) {
      return true;
    }
  }
  return false;
}
/**判断是否在qiankun下 */
function isInQianKun() {
  return window.__POWERED_BY_QIANKUN__;
}

var getFeatureFlagsRequestParams = function getFeatureFlagsRequestParams(data, extra) {
  return {
    optionName: 'crm-base.crmbase.FeatureFlagsService.GetFeatureFlags',
    params: data,
    extra: _extends({
      application_name: 'crm-base',
      service_name: 'FeatureFlagsService',
      method_name: 'GetFeatureFlags',
      protobuf_version: 'v1.0.20220719111148176',
      res_type_name: 'GetFeatureFlagsResponse'
    }, extra)
  };
};

var StorageKey = 'crm.enableFriend';
var StorageVersionKey = 'crm.enableFriend.version';
var getAccountAttrFn = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(webGateway, version) {
    var accountType, _ref2, data, code;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (webGateway) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", '');
        case 2:
          accountType = '';
          _context.next = 5;
          return webGateway(getFeatureFlagsRequestParams());
        case 5:
          _context.t0 = _context.sent;
          if (_context.t0) {
            _context.next = 8;
            break;
          }
          _context.t0 = {};
        case 8:
          _ref2 = _context.t0;
          data = _ref2.data;
          code = _ref2.code;
          if (code === '0') {
            accountType = (data.featureFlags || []).includes('CRM_110_FRIEND_MANAGEMENT') ? 'enableFriend' : 'disableFriend';
            // 缓存当前账户信息，减少白屏时间
            localStorage.setItem(StorageKey, accountType);
            // 在本地存储version，避免二次请求
            localStorage.setItem(StorageVersionKey, version);
          }
          // 默认未开启
          return _context.abrupt("return", accountType);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getAccountAttrFn(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var getRuntimeVersion = function getRuntimeVersion() {
  var _window$runtimeConfig;
  return ((_window$runtimeConfig = window.runtimeConfig) == null ? void 0 : _window$runtimeConfig.ENABLE_FRIEND_VERSION) || '';
};
var checkVersion = function checkVersion(runtimeVersion) {
  if (!runtimeVersion) return true;
  var version = localStorage.getItem(StorageVersionKey) || '';
  return version === runtimeVersion;
};
/**
 * **判断是否开启好友功能**
 *
 * 该函数会先从`LocalStorage`中读取`enableFriend`的值，如果未获取到值才会发起网络请求
 *
 * 使用该函数请确保在主应用中注入运行时的`config.js`
 *
 * ```html
  <script charset="utf-8" src="https://cf-cdn.dustess.com/platform/config.js?t=<%= Date.now() %>" crossorigin></script>
 * ```
 *
 * > 注意：由于utils库中未集成ajax，需要外部传入webGateWay函数用来发起请求
 * @param webGateWay 发起webGateWay请求的函数
 * @param forceUpdate 是否强制发起接口请求，默认为false
 * @returns 是否启用好友功能：
 * - true 启用
 * - false 未启用
 */
var isEnableFriend = /*#__PURE__*/function () {
  var _ref3 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(webGateWay, forceUpdate) {
    var runtimeVersion, accountType;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (forceUpdate === void 0) {
            forceUpdate = false;
          }
          runtimeVersion = getRuntimeVersion();
          accountType = localStorage.getItem(StorageKey) || '';
          if (!(!accountType || forceUpdate || !checkVersion(runtimeVersion))) {
            _context2.next = 7;
            break;
          }
          _context2.next = 6;
          return getAccountAttrFn(webGateWay, runtimeVersion);
        case 6:
          accountType = _context2.sent;
        case 7:
          return _context2.abrupt("return", accountType === 'enableFriend');
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function isEnableFriend(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();

function isThirdApp(platform) {
  if (platform === void 0) {
    platform = 'pc';
  }
  var THIRDAPP_TYPE = 1;
  var isPC = platform === 'pc';
  var userKey = isPC ? 'qw-user' : 'user';
  var user = userStorage.getUser(userKey);
  if (!user || !user.account_type) {
    return false;
  }
  return user.account_type === THIRDAPP_TYPE;
}

/**模板字符串表达式 */
var TemplateRegExp = /\$(user|department)Name=(.+?)\$/g;
/**对接企微OpenData相关逻辑，当且仅当三方应用的场景下才会生效 */
var QWOpenData;
(function (QWOpenData) {
  /**三方应用场景下，初始化画布 */
  function initCanvas(platform) {
    if (platform === void 0) {
      platform = 'pc';
    }
    if (isThirdApp(platform)) {
      var _window$WWOpenData;
      (_window$WWOpenData = window.WWOpenData) == null || _window$WWOpenData.initCanvas();
    }
  }
  QWOpenData.initCanvas = initCanvas;
  /**
   * 判断是否是模板字符串
   * @param text 待校验的文本
   * @returns 是否是模板字符串
   */
  function isTemplateString(text) {
    return !!(text || '').match(TemplateRegExp);
  }
  QWOpenData.isTemplateString = isTemplateString;
  /**
   * 将模板字符串转换成存企微id
   *
   * ```js
   * // 转换'$userName=wxa1ze22d$,12312321$userName=wxa1ze33d$你好'
   * const text = templateToPlainText('$userName=wxa1ze22d$,12312321$userName=wxa1ze33d$你好')
   * console.log(text);
   * //输出：'wxa1ze22d,12312321wxa1ze33d你好'
   * ```
   * @param text 输入待处理的模板字符串
   * @returns 输出纯文本字符串
   */
  function templateToPlainText(text) {
    return (text || '').replaceAll(TemplateRegExp, '$2');
  }
  QWOpenData.templateToPlainText = templateToPlainText;
  /**三方应用场景下，对图表中的数据进行prefetch */
  function prefetch(_x, _x2) {
    return _prefetch.apply(this, arguments);
  }
  function _prefetch() {
    _prefetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(sourceData, option) {
      var _window$WWOpenData2;
      var _option$platform, platform, property, _option$type, type, _option$isTemplateStr, isTemplateString, onModifyItem, items, prefetched, index;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (sourceData != null && sourceData.length) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", []);
          case 2:
            _option$platform = option.platform, platform = _option$platform === void 0 ? 'pc' : _option$platform, property = option.property, _option$type = option.type, type = _option$type === void 0 ? 'userName' : _option$type, _option$isTemplateStr = option.isTemplateString, isTemplateString = _option$isTemplateStr === void 0 ? true : _option$isTemplateStr, onModifyItem = option.onModifyItem;
            if (!(!isThirdApp(platform) || !((_window$WWOpenData2 = window.WWOpenData) != null && _window$WWOpenData2.prefetch))) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return", sourceData);
          case 5:
            if (property) {
              _context.next = 8;
              break;
            }
            console.warn('WWOpenData.prefetch：请指定需要解析的字段名字');
            return _context.abrupt("return", sourceData);
          case 8:
            // 生成需要prefetch的items
            items = sourceData.map(function (it) {
              return {
                type: type,
                id: isTemplateString ? templateToPlainText(it[property]) : it[property]
              };
            });
            _context.prev = 9;
            _context.next = 12;
            return new Promise(function (resolve, reject) {
              var _window$WWOpenData3;
              (_window$WWOpenData3 = window.WWOpenData) == null || _window$WWOpenData3.prefetch({
                items: items
              }, function (err, data) {
                if (err) {
                  return reject(err);
                }
                resolve(data.items || []);
              });
            });
          case 12:
            prefetched = _context.sent;
            index = 0;
            sourceData.forEach(function (it) {
              var _item = prefetched[index];
              if (onModifyItem) {
                onModifyItem(it, _item.data, _item);
              } else {
                it[property] = _item.data;
              }
              index++;
            });
            return _context.abrupt("return", sourceData);
          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](9);
            console.warn('WWOpenData Prefetch Data Error', _context.t0);
          case 21:
            return _context.abrupt("return", sourceData);
          case 22:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[9, 18]]);
    }));
    return _prefetch.apply(this, arguments);
  }
  QWOpenData.prefetch = prefetch;
  /**三方应用场景下，替换富文本中的员工名称或部门名称 */
  function toOpenData(richText, type, platform) {
    if (type === void 0) {
      type = 'userName';
    }
    if (platform === void 0) {
      platform = 'pc';
    }
    var renderText = function renderText(name) {
      return "<span>" + name + "</span>";
    };
    var renderSingleOpenData = function renderSingleOpenData(name) {
      return "<ww-open-data type='" + type + "' openid='" + name + "'/>";
    };
    var renderNameTag = function renderNameTag(name) {
      return isThirdApp(platform) ? renderSingleOpenData(name) : renderText(name);
    };
    var reg = new RegExp("\\$" + type + "\\=.*?\\$", 'g');
    var resultText = richText.replace(reg, function (replaceText) {
      var _replaceText$match;
      var innerReg = new RegExp("(?<=\\$" + type + "\\=).*?(?=\\$)", 'g');
      var correctName = (_replaceText$match = replaceText.match(innerReg)) == null ? void 0 : _replaceText$match[0];
      return renderNameTag(correctName);
    });
    return resultText;
  }
  QWOpenData.toOpenData = toOpenData;
})(QWOpenData || (QWOpenData = {}));

/**
 * @description: 微信图片转缩率图
 * @param {string} url 微信图片链接
 * @return {*}
 */
var wxFilterImg = function wxFilterImg(url) {
  if (url) {
    if (url.indexOf('wework.qpic.cn/') > -1 && url.endsWith('/0')) {
      url = url.replace(/(.*)\/0/, '$1/100');
    }
    if (url.indexOf('wx.qlogo.cn/') > -1 && url.endsWith('/0')) {
      url = url.replace(/(.*)\/0/, '$1/132');
    }
  }
  return url;
};

/*
 * @Date: 2023-02-27 16:59:54
 * @LastEditors: xiaokun
 * @Description: 校验 URL 是否合规
 */
/**
 * @description: 校验 URL 是否合规
 * @param {string} url 需要校验的 URL，只提供基础校验规则
 * @return {boolean}
 */
var isValidURL = function isValidURL(url) {
  // eslint-disable-next-line no-useless-escape
  var reg = /(ht|f)tp(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%$#_]*)?/;
  return reg.test(url);
};

/**
 * @description: 脱敏
 * @param {string} str 需要脱敏的字符串
 * @param {number} start = 3 脱敏开始位置
 * @param {number} end = 7 脱敏结束位置
 * @param {string} maskChar = '*' 脱敏字符
 * @return {string} 返回脱敏后的字符串
 */
function desensitized(str, start, end, maskChar) {
  if (start === void 0) {
    start = 3;
  }
  if (end === void 0) {
    end = 7;
  }
  if (maskChar === void 0) {
    maskChar = '*';
  }
  if (start < 0 || (str == null ? void 0 : str.length) <= start || start > end) {
    return str;
  }
  var maskedPart = maskChar.repeat((end > str.length ? str.length : end) - start);
  var maskedStr = str.slice(0, start) + maskedPart + str.slice(end);
  return maskedStr;
}

/*
 * @Date: 2023-12-12 10:56:29
 * @LastEditors: xiaokun
 * @Description: BI业绩目标值展示
 */
function getBiNumber(number, dataFormat) {
  var num = number;
  var endStr = dataFormat.percent ? '%' : '';
  var startStr = dataFormat.moneySymbol === 'USD' ? '$' : dataFormat.moneySymbol === 'CNY' ? '￥' : '';
  if (dataFormat.precision === '2' || dataFormat.precision === 2) {
    num = Number(num).toFixed(2);
  }
  if (dataFormat.thousand) {
    var sourceArr = String(num).split('.');
    sourceArr[0] = sourceArr[0].replace(new RegExp("(\\d)(?=(\\d{" + 3 + "})+$)", 'ig'), '$1,');
    num = sourceArr.join('.');
  }
  return startStr + num + endStr;
}

var getBindParams = function getBindParams(data, extra) {
  var header = extra && extra.header ? _extends({}, extra.header, {
    'x-api-version': 'v1.0.20240509165727898'
  }) : {
    'x-api-version': 'v1.0.20240509165727898'
  };
  return {
    optionName: 'go-open-ecosystem-center.goopenecosystemcenter.AppAuthService.IsBind',
    params: data,
    extra: _extends({
      application_name: 'go-open-ecosystem-center',
      service_name: 'AppAuthService',
      method_name: 'IsBind',
      protobuf_version: 'v1.0.20240509165727898',
      res_type_name: 'IsBindResponse'
    }, extra, {
      header: header
    })
  };
};

/**
 * 由于utils库中未集成ajax，需要外部传入webGateWay函数用来发起请求
 * @param ops.webGateway 发起webGateWay请求的函数
 * @param ops.service [service: { data: { id , subDomain}, extra: {} }] 接口参数
 * @returns
 */
var isBindMiniProgram = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(ops) {
    var webGateway, service, _ref2, data, code;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          webGateway = ops.webGateway, service = ops.service;
          if (webGateway) {
            _context.next = 5;
            break;
          }
          console.error('未传入webGateWay对象！');
          return _context.abrupt("return", '');
        case 5:
          _context.next = 7;
          return webGateway(getBindParams(service.data, service.extra));
        case 7:
          _context.t0 = _context.sent;
          if (_context.t0) {
            _context.next = 10;
            break;
          }
          _context.t0 = {};
        case 10:
          _ref2 = _context.t0;
          data = _ref2.data;
          code = _ref2.code;
          if (!(code === '0')) {
            _context.next = 15;
            break;
          }
          return _context.abrupt("return", data);
        case 15:
          return _context.abrupt("return", '');
        case 18:
          _context.prev = 18;
          _context.t1 = _context["catch"](0);
          console.error(_context.t1);
          return _context.abrupt("return", _context.t1);
        case 22:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 18]]);
  }));
  return function isBindMiniProgram(_x) {
    return _ref.apply(this, arguments);
  };
}();

var MkQwAccountSvc = function MkQwAccountSvc(request) {
  var MkQwAccountApi = function MkQwAccountApi() {
    var _this = this;
    this.$basePath = '/biz/v1/qw_account';
    this.qwAccountLoginSession = function (params) {
      var path = '/session/get_login_session';
      var url = _this.$basePath + path;
      return request({
        method: 'GET',
        url: url,
        query: params
      });
    };
  };
  return new MkQwAccountApi();
};
var createRequestApi = function createRequestApi(config) {
  if (!config) throw new Error('缺少接口配置config相关参数！');
  if (!config.request) throw new Error('请配置请求方式ajax');
  return MkQwAccountSvc(config.request);
};

/**
 * 由于utils库中未集成ajax，需要外部传入Request函数用来发起请求
 * @param ops.request 发起Request请求的函数
 * @param ops.service [service: { data: { id , subDomain}}] 接口参数
 * @returns
 */
var fetchLoginSession = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(ops) {
    var webapi, req;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          if (ops.request) {
            _context.next = 4;
            break;
          }
          console.error('未传入request对象！');
          return _context.abrupt("return", '');
        case 4:
          webapi = createRequestApi(ops.request);
          _context.next = 7;
          return webapi.qwAccountLoginSession(ops.service.data);
        case 7:
          req = _context.sent;
          if (!(req != null && req.success)) {
            _context.next = 10;
            break;
          }
          return _context.abrupt("return", req == null ? void 0 : req.data);
        case 10:
          return _context.abrupt("return", '');
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);
          return _context.abrupt("return", _context.t0);
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 13]]);
  }));
  return function fetchLoginSession(_x) {
    return _ref.apply(this, arguments);
  };
}();

/*
 * @Date: 2022-03-03 13:48:28
 * @LastEditors: xiaokun
 * @LastEditTime: 2023-03-16 17:37:20
 * @Descripttion: 加解密基础函数
 */
var iv = /*#__PURE__*/cryptoJs.enc.Utf8.parse('0123456789ABCDEF');
/** key 默认为员工 uid */
var defaultKey = function defaultKey() {
  var _ref = userStorage.getUser() || userStorage.getUser('qw-user') || {},
    _ref$uid = _ref.uid,
    uid = _ref$uid === void 0 ? '' : _ref$uid;
  return uid;
};
var crypto = {
  /**
   * @description: 加解密参数
   * @param {string} plain 加解密对象
   * @param {string} key 密钥
   * @return {*}
   */
  encrypt: function encrypt(plain, key) {
    var jsplain = cryptoJs.enc.Utf8.parse("" + plain);
    var cryptoKey = key || defaultKey();
    return cryptoJs.AES.encrypt(jsplain, cryptoJs.MD5(cryptoKey), {
      iv: iv
    }).ciphertext.toString(cryptoJs.enc.Base64) || plain;
  },
  decrypt: function decrypt(encrypted, key) {
    var cryptoKey = key || defaultKey();
    try {
      return cryptoJs.AES.decrypt("" + encrypted, cryptoJs.MD5(cryptoKey), {
        iv: iv
      }).toString(cryptoJs.enc.Utf8).toString() || encrypted;
    } catch (e) {
      return encrypted;
    }
  }
};

function hidePhone(phone, options) {
  if (!phone) return '';
  phone = phone.toString();
  var mergeOptions = _extends({}, {
    matchRange: [6, 14],
    desensitizedRange: [4, 7]
  }, options || {});
  var len = phone.length;
  if (len < mergeOptions.matchRange[0] || len > mergeOptions.matchRange[1]) return phone;
  var tel = '';
  var mobile = /^[0-9-*\s]+$/;
  if (mobile.test(phone)) {
    tel = phone.substring(0, mergeOptions.desensitizedRange[0] - 1) + '****' + phone.substring(mergeOptions.desensitizedRange[1]);
  } else {
    var p = len / 2;
    tel = phone.substring(0, p - 2) + '****' + phone.substring(p + 2);
  }
  return tel;
}
/**
 * @description: 号码加密
 * @param {string} encrypted - 加密对象
 * @param {string | number} key - 密钥
 * @return {string}
 */
function encryptPhone(encrypted, key) {
  var _number = encrypted;
  var decryptNumber = decryptPhone(_number, key, false);
  if (decryptNumber === _number) {
    try {
      _number = crypto.encrypt(encrypted, key);
    } catch (err) {
      // console.log(err)
    }
  }
  return _number;
}
/**
 * @description: 号码解密
 * @param {string | number} encrypted - 解密对象
 * @param {string | number} key - 密钥
 * @param {boolean | HidePhoneOptions} [isHidePhone=true] - 解密后是否需要隐藏号码中间 4 位。 默认需要
 * @return {string}
 */
function decryptPhone(encrypted, key, isHidePhone) {
  if (isHidePhone === void 0) {
    isHidePhone = true;
  }
  var _number = encrypted;
  var test = /^[0-9-*\s]+$/;
  if (!test.test(encrypted)) {
    try {
      if (isHidePhone) {
        _number = hidePhone(crypto.decrypt(encrypted, key), typeof isHidePhone === 'boolean' ? undefined : isHidePhone);
      } else {
        _number = crypto.decrypt(encrypted, key);
      }
    } catch (err) {
      // console.log(err)
    }
  }
  return _number;
}

var promiseCache = /*#__PURE__*/new Map();
var scopeModuleCache = /*#__PURE__*/new Map();
var scopeSet = /*#__PURE__*/new Set();
function loadComponent(scope, module, remoteUrl) {
  function getModule(_x, _x2) {
    return _getModule.apply(this, arguments);
  }
  function _getModule() {
    _getModule = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(scopeName, moduleName) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", new Promise( /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resolve) {
                var _window$proxy, _window$Monitor;
                var token, container, sendCustomError, factory, Module;
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      token = "" + scopeName + moduleName;
                      container = window[scopeName] || ((_window$proxy = window.proxy) == null ? void 0 : _window$proxy[scopeName]);
                      sendCustomError = (_window$Monitor = window.Monitor) == null ? void 0 : _window$Monitor.sendCustomError;
                      if (container) {
                        _context2.next = 10;
                        break;
                      }
                      scopeModuleCache["delete"](token);
                      scopeSet["delete"](scopeName);
                      sendCustomError({
                        message: "\u672A\u83B7\u53D6\u5230container\uFF0C\u8BF7\u68C0\u67E5mf\u7EC4\u4EF6\u5185\u90E8\u4EE3\u7801\uFF0C\u6216\u8BE6\u7EC6\u5728\u4E1A\u52A1\u4E2Ddebug"
                      });
                      resolve({});
                      _context2.next = 26;
                      break;
                    case 10:
                      scopeSet.add(scopeName);
                      _context2.prev = 11;
                      _context2.next = 14;
                      return container.init(__webpack_share_scopes__["default"]);
                    case 14:
                      _context2.next = 16;
                      return container.get(moduleName);
                    case 16:
                      factory = _context2.sent;
                      Module = factory(); // fix default error
                      resolve(Module["default"] || Module);
                      _context2.next = 26;
                      break;
                    case 21:
                      _context2.prev = 21;
                      _context2.t0 = _context2["catch"](11);
                      scopeModuleCache["delete"](token);
                      sendCustomError({
                        message: "\u7EC4\u4EF6\u52A0\u8F7D\u9519\u8BEF\uFF0CremoteUrl:" + remoteUrl + ", \u7EC4\u4EF6scope:" + scopeName + ", \u7EC4\u4EF6\u540D\u79F0:" + moduleName + ", \u8BE6\u7EC6\u9519\u8BEF\u4FE1\u606F:" + (_context2.t0.message || '请检查详细埋点错误信息')
                      });
                      resolve({});
                    case 26:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2, null, [[11, 21]]);
              }));
              return function (_x3) {
                return _ref2.apply(this, arguments);
              };
            }()));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _getModule.apply(this, arguments);
  }
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var token, modulePromise;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          token = "" + scope + module; // 如果已被缓存直接返回
          if (!scopeModuleCache.has(token)) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", scopeModuleCache.get(token));
        case 3:
          if (scopeSet.has(token)) {
            _context.next = 6;
            break;
          }
          _context.next = 6;
          return __webpack_init_sharing__('default');
        case 6:
          modulePromise = getModule(scope, module);
          scopeModuleCache.set(token, modulePromise);
          return _context.abrupt("return", modulePromise);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
}
function loadDynamicScript(url) {
  if (promiseCache.has(url)) {
    return promiseCache.get(url);
  }
  var promise = new Promise(function (resolve) {
    if (!url) {
      resolve({
        success: false,
        msg: '出错，mf url为空'
      });
      return;
    }
    if (promiseCache.has(url)) {
      resolve({
        success: true,
        msg: 'mf url加载命中缓存'
      });
      return;
    }
    var element = document.createElement('script');
    element.src = url;
    element.type = 'text/javascript';
    element.async = true;
    element.onload = function () {
      resolve({
        success: true,
        msg: 'mf url加载成功'
      });
    };
    element.onerror = function () {
      // 被乾坤劫持了，拿不到具体错误。。。。
      resolve({
        success: false,
        msg: 'mf script onerror'
      });
      promiseCache["delete"](url);
    };
    document.head.appendChild(element);
  });
  if (url) {
    promiseCache.set(url, promise);
  }
  return promise;
}
/**移除MF缓存 */
function cleanFederatedCache() {
  console.warn('======开始移除MF缓存=====');
  promiseCache.clear();
  scopeModuleCache.clear();
  scopeSet.clear();
  console.warn('======移除MF缓存成功=====');
}
function loadFederatedComponent(_ref3, module) {
  var remoteUrl = _ref3.remoteUrl,
    scope = _ref3.scope;
  return loadDynamicScript(remoteUrl).then(function (_ref4) {
    var _window$Monitor2;
    var success = _ref4.success,
      msg = _ref4.msg;
    if (success) {
      return loadComponent(scope, module, remoteUrl)();
    }
    var sendCustomError = (_window$Monitor2 = window.Monitor) == null ? void 0 : _window$Monitor2.sendCustomError;
    if (sendCustomError) {
      sendCustomError({
        message: "remoteUrl\u52A0\u8F7D\u9519\u8BEF\uFF0CremoteUrl:" + remoteUrl + "\uFF0C\u8BE6\u7EC6\u9519\u8BEF\u4FE1\u606F: " + msg
      });
    }
    // 加载失败移除缓存
    promiseCache["delete"](remoteUrl);
    // 返回占位组件
    return Promise.resolve({});
  });
}
function preFetchMFComponents(configList) {
  configList.forEach(function (config) {
    var remoteUrl = config.remoteUrl,
      scope = config.scope,
      module = config.module;
    if (remoteUrl) loadDynamicScript(remoteUrl).then(function (_ref5) {
      var _window$Monitor3;
      var success = _ref5.success,
        msg = _ref5.msg;
      if (success && scope && module) {
        loadComponent(scope, module, remoteUrl)();
      }
      var sendCustomError = (_window$Monitor3 = window.Monitor) == null ? void 0 : _window$Monitor3.sendCustomError;
      if (sendCustomError) {
        sendCustomError({
          message: "remoteUrl\u52A0\u8F7D\u9519\u8BEF\uFF0CremoteUrl:" + remoteUrl + "\uFF0C\u8BE6\u7EC6\u9519\u8BEF\u4FE1\u606F: " + msg
        });
      }
    });
  });
}
function addGraySymbol(url) {
  // 去拿_acc_或者account或者corpid，拿到就拼接
  var urlPparams = getUrlQuery();
  var _acc_ = urlPparams._acc_,
    account = urlPparams.account,
    accountId = urlPparams.accountId,
    corpId = urlPparams.corpId;
  var accId = account || accountId || corpId;
  if (_acc_) {
    return url + "?_acc_=" + _acc_;
  }
  if (accId) {
    return url + "?corpId=" + accId;
  }
  // 去本地存储拿accountId，拿到就拼接
  var localUser = localStorage.getItem('platform-user') || localStorage.getItem('qw-user') || localStorage.getItem('user');
  var user = localUser ? JSON.parse(localUser) : {};
  if (user.account) {
    return url + "?corpId=" + user.account;
  }
  return url;
}
function getHost(config) {
  var _window$envConfig;
  var port = config.port,
    _config$publicPath = config.publicPath,
    publicPath = _config$publicPath === void 0 ? '' : _config$publicPath,
    _config$ip = config.ip,
    ip = _config$ip === void 0 ? 'localhost' : _config$ip,
    _config$entryName = config.entryName,
    entryName = _config$entryName === void 0 ? 'remoteEntry' : _config$entryName,
    useRemote = config.useRemote;
  var devUrl = "//" + ip + ":" + port;
  var isDev = process.env.NODE_ENV === 'development';
  var host = isDev ? useRemote ? ((_window$envConfig = window.envConfig) == null ? void 0 : _window$envConfig.VUE_APP_QW_SCRM_BASE_URL) || devUrl : devUrl : window.location.origin;
  var splits = [host];
  var reg = /https?:\/\/[a-zA-Z0-9]+\-(mk|qw)\-/;
  if (publicPath) {
    splits.push(publicPath);
  }
  var needGraySymbol = false;
  // 如果链接上不带corpid，并且是生产环境，就去拼接_acc_或者
  if (!reg.test(host) && (!isDev || useRemote)) {
    needGraySymbol = true;
  }
  splits.push(entryName + ".js");
  var link = splits.join('/');
  return needGraySymbol ? addGraySymbol(link) : link;
}

var URLCache = /*#__PURE__*/new Set();
/**
 * @description: 加载 head 标签
 * @param {string} url 加载地址
 * @param {'js' | 'css'} type 加载类型
 */
var addScript = function addScript(url, type) {
  if (URLCache.has(url)) {
    return;
  }
  if (type === 'css') {
    var link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('type', 'text/css');
    link.setAttribute('href', url);
    document.head.appendChild(link);
  } else {
    var script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', url);
    document.head.appendChild(script);
  }
  URLCache.add(url);
};
var createLink = function createLink(linkUrl) {
  var scriptUrl = linkUrl.script,
    cssUrl = linkUrl.css;
  scriptUrl && addScript(scriptUrl, 'js');
  cssUrl && addScript(cssUrl, 'css');
};

export { Decimal, MoneyUnit, QWOpenData, TemplateRegExp, addScript, cleanFederatedCache, createLink, crypto, dayjs, decryptPhone, desensitized, download, durationFormat, encryptPhone, fetchLoginSession, formatDateTime, formatFileSize, formatFileSizeByUnit, formatMoney, formatSeconds, getBiNumber, getDecorateOrigin, getDomainAffix, getHost, getUrlQuery, hidePhone, isBindMiniProgram, isEllipsis, isEnableFriend, isInQianKun, isLoadScript, isThirdApp, isValidURL, loadFederatedComponent, preFetchMFComponents, storage, userStorage, wxFilterImg };
//# sourceMappingURL=iutils.esm.js.map
